// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__18AtS","head":"ProcedureTableInfo_head__qXnhn"};